import { Box } from "@mui/material";
import React from "react";
import classess from "./Style.module.css";

const Possessivartikel2 = () => {
  const Title = [
    "ضمیر فاعلی",
    "مذکر - DEN",
    "مونث - DIE",
    "خنثی - DAS",
    "جمع - DIE",
  ];
  const ST1 = ["ICH", "meinen", "meine", "mein", "meine"];
  const ST2 = ["DU", "deinen", "deine", "dein", "deine"];
  const ST3 = ["ER", "seinen", "seine", "sein", "seine"];
  const ST4 = ["SIE او", "ihren", "ihre", "ihr", "ihre"];
  const ST5 = ["ES", "seinen", "seine", "sein", "seine"];
  const ST6 = ["WIR", "unseren", "unsere", "unser", "unsere"];
  const ST7 = ["IHR شما - غیر رسمی", "euren", "eure", "euer", "eure"];
  const ST8 = ["SIE آنها", "ihren", "ihre", "ihr", "ihre"];
  const ST9 = ["Sie شما - محترمانه", "Ihren", "Ihre", "Ihr", "Ihre"];
  return (
    <Box className={classess.Wrapper}>
      <span>۲. ضمایر ملکی در حالت مفعولی مستقیم (Akkusativ)</span>
      <Box className={classess.WP}>
        {Title.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                backgroundColor: "rgba(150, 150, 150, 0.1)",
                fontSize: "0.9rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST2.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST3.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST4.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={index === 3 ? "IIGHEN" : index === 2 ? "IGHE" : null}
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST5.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST6.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
                cursor: index === 4 ? null : "pointer",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={
                    index === 0 || index === 2
                      ? "ONZEGHE"
                      : index === 1
                      ? "ONZA"
                      : "ONZEGHEN"
                  }
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST7.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
                cursor: index === 4 ? null : "pointer",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={
                    index === 0 || index === 2
                      ? "AIGHE"
                      : index === 1
                      ? "AIA"
                      : "AIGHEN"
                  }
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST8.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST9.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.Footers}>
        <span>
          Akkusativ: „{" "}
          <label className={classess.Label}>Ich sehe meinen Vater.</label>“
        </span>
        <span className={classess.Span}>( من پدرم را میبینم )</span>
        <span style={{ marginTop: "8px" }}>
          Akkusativ : „{" "}
          <label className={classess.Label}>Ich liebe meine Mutter.</label>“
        </span>
        <span className={classess.Span}>( من مادرم را دوست دارم )</span>
        <span style={{ marginTop: "8px" }}>
          Akkusativ : „{" "}
          <label className={classess.Label}>Ich finde mein Buch. </label>“
        </span>
        <span className={classess.Span}>( من کتابم را پیدا میکنم )</span>
        <span style={{ marginTop: "8px" }}>
          Akkusativ : „{" "}
          <label className={classess.Label}>Ich besuche meine Freunde .</label>“
        </span>
        <span className={classess.Span}>( من دوستانم را ملاقات میکنم )</span>
      </Box>
    </Box>
  );
};

export default Possessivartikel2;
